/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import TextField from '@material-ui/core/TextField';
import {
  maintainContractActions,
  handleErrorMessages,
  getInvContactDetails,
} from '../store/actions';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import SelectContractModal from './SelectContractModal';
import CommonModal from './CommonModal';
import { ShowContractUsingContacts } from './CreateContractModal';

const InvoiceContact = ({ isEnablebyRole = true }) => {
  const dispatch = useDispatch();
  const maintainContractState = useSelector(
    (state) => state.sharedState.ContractReducer.maintainContractState
  );
  const invoiceContact = useSelector(
    (state) =>
      state.sharedState.ContractReducer.maintainContractState.invoiceContact
  );
  const searchContractState = useSelector(
    (state) => state.sharedState.ContractReducer.searchContractState
  );
  const errorMessagesFromRedux = useSelector((state) => {
    return state?.sharedState?.ContractReducer?.errorMessagesInRedux;
  });
  const getInvoiceContractContactDetails = useSelector(
    (state) =>
      state.sharedState?.ContractReducer?.getInvoiceContractContactDetails
  );
  const [windowWidth, setWindowWidth] = React.useState(window.screen.width);
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = today.getMonth() + 1; // Months start at 0!
  const dd = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();
  const currDate = `${mm}/${dd}/${yyyy}`;
  // const logInUserID = localStorage.getItem('logInUser');
  const [showContractPop, setShowContractPop] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const copyContract = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  //Set lable text according to the screen width for Phone number
  const textReplace = () => {
    setWindowWidth(window.screen.width);
  };
  React.useEffect(() => {
    window.addEventListener('resize', textReplace);
  }, [windowWidth]);

  React.useEffect(() => {
    if (
      getInvoiceContractContactDetails &&
      Object.keys(getInvoiceContractContactDetails).length > 0
    ) {
      const data = { ...invoiceContact };
      let localErr = errorMessagesFromRedux || [];
      let selectedContact = { ...getInvoiceContractContactDetails };
      data.manufacturerID = selectedContact.mfgId || '';
      data.manufacturerName = selectedContact.mfgName || '';
      data.contactTypeCode = selectedContact.contactTypeCd || '';
      data.description = selectedContact.shortDescr || '';
      data.contactName = selectedContact.contactName || '';
      data.corpName = selectedContact.corpName || '';
      data.addrLine1 = selectedContact.addrLine1 || '';
      data.addrLine2 = selectedContact.addrLine2 || '';
      data.addrLine3 = selectedContact.addrLine3 || '';
      data.city = selectedContact.city || '';
      data.stateCd = selectedContact.stateCd || '';
      data.zip = selectedContact.zip || '';
      data.zip4 = selectedContact.zip4 || '';
      data.phoneNum = selectedContact.phoneNum || '';
      data.phoneExtension = selectedContact.phoneExtension || '';
      data.faxNum = selectedContact.faxNum || '';
      data.email = selectedContact.email || '';
      data.addressChangedInd = selectedContact.addressChangedInd || '';
      data.contactSeqNum = selectedContact.contactSeqNum || '';
      data.contactTypeCd = selectedContact.contactTypeCd || null;
      data.copySourceSeqNum = selectedContact.copySourceSeqNum || null;
      data.corrLinkId = selectedContact.corrLinkId || null;
      data.key = selectedContact.mfgId;
      data.keyTypeCd = selectedContact.keyTypeCd;
      data.lastUpdateDT = `${currDate} 00:00`;
      data.lastUpdateUserID = logInUser;
      data.nameChangedInd = selectedContact.nameChangedInd || null;
      data.needsAttentionCd = selectedContact.needsAttentionCd || null;

      const newdata = {
        ...maintainContractState,
        invoiceContact: {
          ...invoiceContact,
          ...data,
        },
      };
      dispatch(maintainContractActions(newdata));
      localErr = localErr?.filter((x) => x.tabName !== 'InvoiceContact');
      dispatch(handleErrorMessages([...new Set(localErr)]));
    }
  }, [getInvoiceContractContactDetails]);
  const setContactIfNotEmpty = (data) => {
    if (data) {
      dispatch(
        getInvContactDetails({
          invContactSeqNum: data.contactSeqNum,
          type: 'Invoice',
        })
      );
    }
    handleClose();
  };
  const showContactingContact = () => {
    setShowContractPop(true);
  };
  return (
    <div data-testid="InvoiceContact-component">
      <div className="float-right">
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="action-tooltip">Action</Tooltip>}
        >
          <Dropdown className="icon-dropdown-container frr-lab-diff-action-icon-container">
            <Dropdown.Toggle
              className="icon-dropdown"
              aria-label="Show Contracts using this Contact"
            >
              <SVGComponent iconName="Icon-export" />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item
                role="button"
                data-testid="showContact"
                disabled={searchContractState.contractType !== 'onSelect'}
                onClick={() => {
                  if (searchContractState.contractType === 'onSelect') {
                    showContactingContact();
                  }
                }}
              >
                Show Contracts using this Contact
              </Dropdown.Item>
              <Dropdown.Item
                role="button"
                data-testid="copyContact"
                disabled={!isEnablebyRole}
                onClick={() => {
                  copyContract();
                }}
              >
                Copy Contact From
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </OverlayTrigger>
      </div>
      <div className="my-3 pt-4 frr-invoice-contant">
        <fieldset className="custom-fieldset" style={{ height: 'auto' }}>
          <legend className="same-font-family">Search Criteria</legend>

          <div className="form-wrapper db">
            <div className="row">
              <div className="col-12 col-sm-3 col-lg-4 col-xl-3">
                <div className="mui-custom-form input-md">
                  <TextField
                    id="ManufacturerID"
                    //required
                    disabled
                    className="mandate-fields"
                    label="Manufacturer ID"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ id: 'ManufacturerID' }}
                    value={invoiceContact?.manufacturerID}
                    helperText={
                      errorMessagesFromRedux?.length > 0
                        ? [
                            ...new Set(
                              errorMessagesFromRedux
                                ?.filter(
                                  (x) =>
                                    x.fieldName === 'manufacturerID' &&
                                    x.tabName === 'InvoiceContact'
                                )
                                .map((item) => {
                                  return item.subMessage || item.message;
                                })
                            ),
                          ]
                        : null
                    }
                    error={
                      errorMessagesFromRedux?.length > 0 &&
                      errorMessagesFromRedux?.filter(
                        (x) =>
                          x.fieldName === 'manufacturerID' &&
                          x.tabName === 'InvoiceContact'
                      ).length > 0
                        ? [
                            ...new Set(
                              errorMessagesFromRedux
                                ?.filter(
                                  (x) =>
                                    x.fieldName === 'manufacturerID' &&
                                    x.tabName === 'InvoiceContact'
                                )
                                .map((item) => {
                                  return item.subMessage || item.message;
                                })
                            ),
                          ]
                        : false
                    }
                  />
                </div>
              </div>

              <div className="col-12 col-sm-3 col-lg-4 col-xl-3">
                <div className="mui-custom-form input-md">
                  {invoiceContact?.manufacturerName?.length > 20 ? (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="com-tooltip">
                          {invoiceContact?.manufacturerName}
                        </Tooltip>
                      }
                    >
                      <TextField
                        id="ManufacturerName"
                        //required
                        disabled
                        className="mandate-fields"
                        label="Manufacturer Name"
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ id: 'ManufacturerName' }}
                        value={invoiceContact?.manufacturerName}
                        helperText={
                          errorMessagesFromRedux?.length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter(
                                      (x) =>
                                        x.fieldName === 'manufacturerName' &&
                                        x.tabName === 'InvoiceContact'
                                    )
                                    .map((item) => {
                                      return item.subMessage || item.message;
                                    })
                                ),
                              ]
                            : null
                        }
                        error={
                          errorMessagesFromRedux?.length > 0 &&
                          errorMessagesFromRedux?.filter(
                            (x) =>
                              x.fieldName === 'manufacturerName' &&
                              x.tabName === 'InvoiceContact'
                          ).length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter(
                                      (x) =>
                                        x.fieldName === 'manufacturerName' &&
                                        x.tabName === 'InvoiceContact'
                                    )
                                    .map((item) => {
                                      return item.subMessage || item.message;
                                    })
                                ),
                              ]
                            : false
                        }
                      />
                    </OverlayTrigger>
                  ) : (
                    <TextField
                      id="ManufacturerName"
                      //required
                      disabled
                      className="mandate-fields"
                      label="Manufacturer Name"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ id: 'ManufacturerName' }}
                      value={invoiceContact?.manufacturerName}
                      helperText={
                        errorMessagesFromRedux?.length > 0
                          ? [
                              ...new Set(
                                errorMessagesFromRedux
                                  ?.filter(
                                    (x) =>
                                      x.fieldName === 'manufacturerName' &&
                                      x.tabName === 'InvoiceContact'
                                  )
                                  .map((item) => {
                                    return item.subMessage || item.message;
                                  })
                              ),
                            ]
                          : null
                      }
                      error={
                        errorMessagesFromRedux?.length > 0 &&
                        errorMessagesFromRedux?.filter(
                          (x) =>
                            x.fieldName === 'manufacturerName' &&
                            x.tabName === 'InvoiceContact'
                        ).length > 0
                          ? [
                              ...new Set(
                                errorMessagesFromRedux
                                  ?.filter(
                                    (x) =>
                                      x.fieldName === 'manufacturerName' &&
                                      x.tabName === 'InvoiceContact'
                                  )
                                  .map((item) => {
                                    return item.subMessage || item.message;
                                  })
                              ),
                            ]
                          : false
                      }
                    />
                  )}
                </div>
              </div>

              <div className="col-12 col-sm-3 col-lg-4 col-xl-3">
                <div className="mui-custom-form input-md ">
                  <TextField
                    id="ContactTypeCode"
                    className="mandate-fields"
                    label="Contact Type Code"
                    //required
                    disabled
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ id: 'ContactTypeCode' }}
                    value={invoiceContact?.contactTypeCode}
                    helperText={
                      errorMessagesFromRedux?.length > 0
                        ? [
                            ...new Set(
                              errorMessagesFromRedux
                                ?.filter(
                                  (x) =>
                                    x.fieldName === 'contactTypeCode' &&
                                    x.tabName === 'InvoiceContact'
                                )
                                .map((item) => {
                                  return item.subMessage || item.message;
                                })
                            ),
                          ]
                        : null
                    }
                    error={
                      errorMessagesFromRedux?.length > 0 &&
                      errorMessagesFromRedux?.filter(
                        (x) =>
                          x.fieldName === 'contactTypeCode' &&
                          x.tabName === 'InvoiceContact'
                      ).length > 0
                        ? [
                            ...new Set(
                              errorMessagesFromRedux
                                ?.filter(
                                  (x) =>
                                    x.fieldName === 'contactTypeCode' &&
                                    x.tabName === 'InvoiceContact'
                                )
                                .map((item) => {
                                  return item.subMessage || item.message;
                                })
                            ),
                          ]
                        : false
                    }
                  />
                </div>
              </div>

              <div className="col-12 col-sm-3 col-lg-4 col-xl-3">
                <div className="mui-custom-form input-md">
                  {invoiceContact?.description?.length > 20 ? (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="com-tooltip">
                          {invoiceContact?.description}
                        </Tooltip>
                      }
                    >
                      <TextField
                        id="Description"
                        className="mandate-fields"
                        label="Description"
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ id: 'Description' }}
                        value={invoiceContact?.description}
                        disabled
                        helperText={
                          errorMessagesFromRedux?.length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter(
                                      (x) =>
                                        x.fieldName === 'description' &&
                                        x.tabName === 'InvoiceContact'
                                    )
                                    .map((item) => {
                                      return item.subMessage || item.message;
                                    })
                                ),
                              ]
                            : null
                        }
                        error={
                          errorMessagesFromRedux?.length > 0 &&
                          errorMessagesFromRedux?.filter(
                            (x) =>
                              x.fieldName === 'description' &&
                              x.tabName === 'InvoiceContact'
                          ).length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter(
                                      (x) =>
                                        x.fieldName === 'description' &&
                                        x.tabName === 'InvoiceContact'
                                    )
                                    .map((item) => {
                                      return item.subMessage || item.message;
                                    })
                                ),
                              ]
                            : false
                        }
                      />
                    </OverlayTrigger>
                  ) : (
                    <TextField
                      id="Description"
                      className="mandate-fields"
                      label="Description"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ id: 'Description' }}
                      value={invoiceContact?.description}
                      disabled
                      helperText={
                        errorMessagesFromRedux?.length > 0
                          ? [
                              ...new Set(
                                errorMessagesFromRedux
                                  ?.filter(
                                    (x) =>
                                      x.fieldName === 'description' &&
                                      x.tabName === 'InvoiceContact'
                                  )
                                  .map((item) => {
                                    return item.subMessage || item.message;
                                  })
                              ),
                            ]
                          : null
                      }
                      error={
                        errorMessagesFromRedux?.length > 0 &&
                        errorMessagesFromRedux?.filter(
                          (x) =>
                            x.fieldName === 'description' &&
                            x.tabName === 'InvoiceContact'
                        ).length > 0
                          ? [
                              ...new Set(
                                errorMessagesFromRedux
                                  ?.filter(
                                    (x) =>
                                      x.fieldName === 'description' &&
                                      x.tabName === 'InvoiceContact'
                                  )
                                  .map((item) => {
                                    return item.subMessage || item.message;
                                  })
                              ),
                            ]
                          : false
                      }
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <div className="my-2">
        <form autoComplete="off">
          <div className="frr-invoice-other-info">
            <fieldset className="custom-fieldset custom-height">
              <legend aria-hidden="true" className="d-none" />
              <div className="form-wrapper">
                <div className="line-break-div" />
                <div className="mui-custom-form input-md">
                  <TextField
                    id="Name"
                    label="Name"
                    data-testid="name"
                    className="mandate-fields"
                    fullWidth
                    placeholder=""
                    inputProps={{ maxLength: 50, id: 'Name' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    value={invoiceContact?.contactName}
                  />
                </div>
                <div className="mui-custom-form input-md">
                  <TextField
                    id="CorporationName"
                    label="Corporation Name"
                    data-testid="Corporation-name"
                    fullWidth
                    placeholder=""
                    inputProps={{ maxLength: 50, id: 'CorporationName' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    value={invoiceContact?.corpName}
                  />
                </div>
                <div className="mui-custom-form input-md" />
                <div className="line-break-div" />
                <div className="mui-custom-form input-md">
                  <TextField
                    id="Address Lines"
                    data-testid="Address-line"
                    label="Address Lines 1"
                    className="mandate-fields"
                    fullWidth
                    placeholder=""
                    inputProps={{ maxLength: 50, id: 'Address Lines' }}
                    InputLabelProps={{ shrink: true }}
                    disabled
                    value={invoiceContact?.addrLine1}
                  />
                </div>
                <div className="mui-custom-form input-md">
                  <TextField
                    id="Addressline2"
                    label="Address Lines 2"
                    data-testid="address-line2"
                    fullWidth
                    placeholder=""
                    inputProps={{ maxLength: 50, id: 'Addressline2' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={invoiceContact?.addrLine2}
                    disabled
                  />
                </div>
                <div className="mui-custom-form input-md">
                  <TextField
                    id="Addressline3"
                    label="Address Lines 3"
                    data-testid="address-lines3"
                    fullWidth
                    placeholder=""
                    inputProps={{ maxLength: 50, id: 'Addressline3' }}
                    InputLabelProps={{ shrink: true }}
                    value={invoiceContact?.addrLine3}
                    disabled
                  />
                </div>
                <div className="line-break-div" />
                <div className="mui-custom-form input-md">
                  <TextField
                    id="city"
                    data-testid="city"
                    label="City"
                    className="mandate-fields"
                    fullWidth
                    placeholder=""
                    inputProps={{ maxLength: 30, id: 'city' }}
                    InputLabelProps={{ shrink: true }}
                    value={invoiceContact?.city}
                    disabled
                  />
                </div>
                <div className="mui-custom-form input-md">
                  <TextField
                    id="state"
                    label="State"
                    data-testid="state"
                    className="mandate-fields"
                    fullWidth
                    placeholder=""
                    inputProps={{ maxLength: 2, id: 'state' }}
                    InputLabelProps={{ shrink: true }}
                    value={invoiceContact?.stateCd}
                    disabled
                  />
                </div>
                <div className="mui-custom-form input-md">
                  <div className="row">
                    <div className="col-sm-6 col-md-7 pr-sm-0 pr-md-2">
                      <TextField
                        id="Zip"
                        label="Zip"
                        data-testid="zip"
                        className="mandate-fields"
                        fullWidth
                        placeholder=""
                        inputProps={{ maxLength: 10, id: 'Zip' }}
                        InputLabelProps={{ shrink: true }}
                        value={invoiceContact?.zip}
                        disabled
                      />
                    </div>
                    <div className="col-sm-6 col-md-5 mt-md-0 pl-md-0">
                      <TextField
                        id="Zip+4"
                        label="Zip+4"
                        data-testid="zip4"
                        fullWidth
                        placeholder=""
                        inputProps={{ maxLength: 4, id: 'Zip+4' }}
                        InputLabelProps={{ shrink: true }}
                        value={
                          invoiceContact?.zip4 !== null &&
                          invoiceContact?.zip4 !== ''
                            ? invoiceContact?.zip4
                            : ''
                        }
                        disabled
                        helperText={
                          errorMessagesFromRedux?.length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter((x) => {
                                      return (
                                        x.fieldName === 'zip4' &&
                                        x.tabName === 'InvoiceContact'
                                      );
                                    })
                                    .map((item) => {
                                      return item.subMessage || item.message;
                                    })
                                ),
                              ]
                            : null
                        }
                        error={
                          errorMessagesFromRedux?.length > 0 &&
                          errorMessagesFromRedux?.filter((x) => {
                            return (
                              x.fieldName === 'zip4' &&
                              x.tabName === 'InvoiceContact'
                            );
                          }).length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter((x) => {
                                      return (
                                        x.fieldName === 'zip4' &&
                                        x.tabName === 'InvoiceContact'
                                      );
                                    })
                                    .map((item) => {
                                      return item.subMessage || item.message;
                                    })
                                ),
                              ]
                            : false
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="line-break-div" />
                <div className="mui-custom-form input-md">
                  <div className="row">
                    <div className="col-sm-6 col-md-7 pr-sm-0 pr-md-2">
                      <TextField
                        id="Phone Number"
                        label={
                          windowWidth >= 745 ? 'Phone Number' : 'Phone No.'
                        }
                        data-testid="phone"
                        className="mandate-fields"
                        fullWidth
                        placeholder=""
                        inputProps={{ maxLength: 10, id: 'Phone Number' }}
                        InputLabelProps={{ shrink: true }}
                        value={
                          invoiceContact?.phoneNum
                            ? invoiceContact?.phoneNum.trim()
                            : ''
                        }
                        disabled
                        helperText={
                          errorMessagesFromRedux?.length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter((x) => {
                                      return (
                                        x.fieldName === 'phoneNum' &&
                                        x.tabName === 'InvoiceContact'
                                      );
                                    })
                                    .map((item) => {
                                      return item.subMessage || item.message;
                                    })
                                ),
                              ]
                            : null
                        }
                        error={
                          errorMessagesFromRedux?.length > 0 &&
                          errorMessagesFromRedux?.filter((x) => {
                            return (
                              x.fieldName === 'phoneNum' &&
                              x.tabName === 'InvoiceContact'
                            );
                          }).length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter((x) => {
                                      return (
                                        x.fieldName === 'phoneNum' &&
                                        x.tabName === 'InvoiceContact'
                                      );
                                    })
                                    .map((item) => {
                                      return item.subMessage || item.message;
                                    })
                                ),
                              ]
                            : false
                        }
                      />
                    </div>
                    <div className="col-sm-6 col-md-5 mt-md-0 pl-md-0">
                      <TextField
                        id="Extension"
                        label="Extension"
                        data-testid="Extension"
                        fullWidth
                        placeholder=""
                        inputProps={{ maxLength: 6, id: 'Extension' }}
                        InputLabelProps={{ shrink: true }}
                        value={invoiceContact?.phoneExtension}
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div className="mui-custom-form input-md">
                  <TextField
                    id="Fax Number"
                    label="Fax Number"
                    data-testid="fax"
                    fullWidth
                    placeholder=""
                    inputProps={{ maxLength: 10, id: 'Fax Number' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    value={invoiceContact?.faxNum}
                  />
                </div>
                <div className="mui-custom-form input-md">
                  <TextField
                    id="Email Address"
                    label="Email Address"
                    data-testid="email"
                    className="mandate-fields"
                    fullWidth
                    type="text"
                    placeholder=""
                    inputProps={{ maxLength: 50, id: 'Email Address' }}
                    InputLabelProps={{ shrink: true }}
                    disabled
                    value={invoiceContact?.email}
                    helperText={
                      errorMessagesFromRedux?.length > 0
                        ? [
                            ...new Set(
                              errorMessagesFromRedux
                                ?.filter((x) => {
                                  return (
                                    x.fieldName === 'email' &&
                                    x.tabName === 'InvoiceContact'
                                  );
                                })
                                .map((item) => {
                                  return item.subMessage || item.message;
                                })
                            ),
                          ]
                        : null
                    }
                    error={
                      errorMessagesFromRedux?.length > 0 &&
                      errorMessagesFromRedux?.filter((x) => {
                        return (
                          x.fieldName === 'email' &&
                          x.tabName === 'InvoiceContact'
                        );
                      }).length > 0
                        ? [
                            ...new Set(
                              errorMessagesFromRedux
                                ?.filter((x) => {
                                  return (
                                    x.fieldName === 'email' &&
                                    x.tabName === 'InvoiceContact'
                                  );
                                })
                                .map((item) => {
                                  return item.subMessage || item.message;
                                })
                            ),
                          ]
                        : false
                    }
                  />
                </div>
              </div>
            </fieldset>
          </div>
        </form>
      </div>

      <SelectContractModal
        disputeContract={false}
        invoiceContact
        setSelectedContact={setSelectedContact}
        open={open}
        handleClose={handleClose}
        setContactIfNotEmpty={setContactIfNotEmpty}
      />
      <CommonModal
        open={showContractPop}
        viewAction
        viewHeader
        modalTitle="Show Contracts using this Contact"
        className="panel-header"
        okTitle="Ok"
        onOk={() => {
          setShowContractPop(false);
        }}
        onClose={() => {
          setShowContractPop(false);
        }}
        childrenComponent={
          <ShowContractUsingContacts
            contactSeqNum={invoiceContact.contactSeqNum}
          />
        }
      />
    </div>
  );
};
export default InvoiceContact;
